import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, Renderer2, signal, inject } from '@angular/core';
import { User } from '@models/user';
import { PageEvent } from '@classi/spen';
import { LayoutService } from '@components/layout/layout.service';
import { SpaceService } from '@components/space/space.service';

@Component({
  selector: 'app-modal-participants-list',
  templateUrl: './modal-participants-list.component.html',
  styleUrls: ['./modal-participants-list.component.scss'],
  standalone: false,
})
export class ModalParticipantsListComponent implements OnInit, OnDestroy {
  layoutService = inject(LayoutService);
  spaceService = inject(SpaceService);
  private renderer = inject(Renderer2);

  @Input() spaceId: number;
  @Output() eventCancel = new EventEmitter<boolean>();

  tabs = ['student', 'teacher'];
  currentTab = 'student';
  studentsLoaded = false;
  teachersLoaded = false;
  errMsg: string;
  teachers: Array<User> = [];
  students: Array<User> = [];
  queryParams = {};

  readonly teacherPage = signal({
    current_page: 1,
    next_page: null,
    per_page: 50,
    prev_page: null,
    total_count: 0,
    total_pages: 0,
    students_count: 0,
    teachers_count: 0,
    create_user_id: null,
  });

  readonly studentPage = signal({
    current_page: 1,
    next_page: null,
    per_page: 50,
    prev_page: null,
    total_count: 0,
    total_pages: 0,
    students_count: 0,
    teachers_count: 0,
    create_user_id: null,
  });

  ngOnInit() {
    this.renderer.addClass(document.body, 'modal-open');
    this.queryParams['page'] = 1;
    this.loadStudentsList();
    this.loadTeachersList();
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  loadStudentsList() {
    this.studentsLoaded = false;
    this.queryParams['user_type'] = 'student';
    this.spaceService.getSpaceParticipantsList(this.spaceId, this.queryParams).subscribe(
      (response) => {
        this.students = response.users;
        this.studentPage.set(response.meta);
        this.studentsLoaded = true;
      },
      (error) => {
        this.errMsg = <any>error;
      },
    );
  }

  loadTeachersList() {
    this.teachersLoaded = false;
    this.queryParams['user_type'] = 'teacher';
    this.spaceService.getSpaceParticipantsList(this.spaceId, this.queryParams).subscribe(
      (response) => {
        this.teachers = response.users;
        this.teacherPage.set(response.meta);
        this.teachersLoaded = true;
      },
      (error) => {
        this.errMsg = <any>error;
      },
    );
  }

  get showTeacherPagination(): boolean {
    return this.teacherPage().total_pages > 1 && this.teacherTab;
  }

  get showStudentPagination(): boolean {
    return this.studentPage().total_pages > 1 && !this.teacherTab;
  }

  get teacherTab(): boolean {
    return this.currentTab === 'teacher';
  }

  get dataLoaded(): boolean {
    return this.teachersLoaded && this.studentsLoaded;
  }

  currentPagination() {
    return this.teacherTab ? this.teacherPage() : this.studentPage();
  }

  pageChanged({ index }: PageEvent) {
    this.queryParams['page'] = index + 1;
    this.teacherTab ? this.loadTeachersList() : this.loadStudentsList();
    window.scrollTo(0, 0);
  }

  changeTab(tabName: string) {
    this.currentTab = tabName;
  }

  onClose() {
    this.eventCancel.emit(false);
  }
}
